import * as classes from "../css/patient-slider-physiolymp.module.css";
import {transition} from "./util/transition";
import {useEmblaCarousel} from "embla-carousel/react";
import React, {useEffect, useState} from "react";
import {useInView} from "react-intersection-observer";
import ambimaxLogo from "../images/AX-logo-WBC-OS-RGB.png"
import retailsolutionLogo from "../images/AX-logo-WB-W-profile.jpg"

export default function Patienten(): React.ReactElement {
  const {ref, inView} = useInView({
    threshold: 0,
    rootMargin: "200px 0px -200px 0px",
    initialInView: true,
  });

  const [emblaRef, embla] = useEmblaCarousel({
    loop: true,
    startIndex: 0,
  });

  const [selected, setSelected] = useState(0);

  useEffect(() => {
    if (!embla) {
      return;
    }

    embla.on("select", () => {
      setSelected(embla.selectedScrollSnap());
    });
  }, [embla]);

  return (
    <div ref={ref} className="py-12 md:py-32">
      <div
        className={classes.title}
        style={{
          transition: transition(inView, 0),
          transform: `translateY(${inView ? "0" : "-1rem"})`,
          opacity: inView ? 1 : 0,
        }}
      >
        Meine{" "}
        <span className="uppercase text-yellow-400 font-bold">Patienten</span>
      </div>
      <div className={classes.embla} ref={emblaRef}>
        <div className={classes.embla__container}>
          <Slide index={0} selected={selected} entry={{name: "ambimax", logo: ambimaxLogo}}></Slide>
          <Slide index={1} selected={selected} entry={{name: "retail solution", logo: retailsolutionLogo}}></Slide>
        </div>
      </div>
    </div>
  );
}

interface SlideProps {
  selected: number,
  index: number,
  entry?: { name: string; logo: string }
}

function Slide({selected, index, entry}: SlideProps): React.ReactElement {
  return (
    <div
      className={`${classes.embla__slide} ${
        selected === index ? classes.embla__slide__selected : ""
      }`}
    >
      <div
        aria-label={entry}
        className={classes.logo}
        style={{
          backgroundImage: `url(${entry.logo})`,
          backgroundSize: "contain",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
        }}
      ></div>
    </div>
  );
}
